import algoliaSearch from "algoliasearch";

import { createBrowserLocalStorageCache } from "@algolia/cache-browser-local-storage";
import { createFallbackableCache } from '@algolia/cache-common';
import { createInMemoryCache } from '@algolia/cache-in-memory';
import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";

export let index                 = () => {
    if (typeof algolia_index_name === 'string') {
        return algolia_index_name;
    }

    if (process.env.NODE_ENV === 'development') {
        console.warn('algolia_index_name does not seem valid!', algolia_index_name);
    }

    return null;
};
export let querySuggestionsIndex = () => {
    if (typeof algolia_query_suggestions_index_name === 'string') {
        return algolia_query_suggestions_index_name;
    }

    if (process.env.NODE_ENV === 'development') {
        console.warn('algolia_query_suggestions_index_name does not seem valid!', algolia_query_suggestions_index_name);
    }

    return null;
};
export let meilisearchSuggestionsIndex = () => {
    return querySuggestionsIndex();
};



export let algoliaAppId = () => {
    if (typeof algolia_app_id !== 'undefined') {
        return algolia_app_id;
    }

    return null;
};
export let meiliHost = () => {
    if (typeof meilisearch_host !== 'undefined') {
        return meilisearch_host;
    }

    return null;
};


export let meiliApiKey = () => {
    if (typeof meili_api_key !== 'undefined') {
        return meili_api_key;
    }

    return null;
};

export let algoliaKeySearch = () => {
    if (typeof algolia_key_search !== 'undefined') {
        return algolia_key_search;
    }

    return null;
};

/**
 * Algolia client with TTL cache (Items expire after 1 month)
 *
 */
export const algoliaClient = () => {
    if (! meiliHost && ! meiliApiKey) {
        return null;
    }

    return instantMeiliSearch(
        meiliHost(),
        meiliApiKey(),
        {
            finitePagination: true,
            meiliSearchParams: {
                matchingStrategy: 'all',
            },
        }
    ).searchClient;
};

/**
 * Algolia client with TTL cache (Items expire at 00:00)
 *
 * @return {null|SearchClient}
 */
export const algoliaClientShortTTL                    = () => {
    if (! meiliHost && ! meiliApiKey) {
        return null;
    }

    const midnightTimestamp = new Date();
    midnightTimestamp.setHours(24);
    midnightTimestamp.setMinutes(0);
    midnightTimestamp.setSeconds(0);
    midnightTimestamp.setMilliseconds(0);

    const secondsUntilMidnight = (midnightTimestamp.getTime() - new Date().getTime()) / 1000;


    const { searchClient } =  instantMeiliSearch(
        meiliHost(),
        meiliApiKey(),
        {
            finitePagination: true,
            meiliSearchParams: {
                matchingStrategy: 'all',
            },
        }
    );

    return searchClient;
};
export const deleteOldAlgoliaBrowserLocalStorageCache = () => {
    window.localStorage.removeItem(`algoliasearch-client-js-brekz-responses-cache`);
    window.localStorage.removeItem(`brekz-algoliasearch-client-js-brekz-responses-cache`);
    window.localStorage.removeItem(`brekz-algoliasearch-client-js-brekz-responses-cache-short`);
};

export const getAlgoliaInsightsToken = (idCustomer) => {
    return `authenticated-${idCustomer}`;
};

export const getAlgoliaInsightsAnonymousToken = () => {
    const anonymousTokenKey = `algoliasearch-insights-anonymous-token`;
    let anonymousToken      = window.localStorage.getItem(anonymousTokenKey);

    if (anonymousToken) {
        return anonymousToken;
    }

    anonymousToken = `anonymous-${new Date().getTime()}`;

    window.localStorage.setItem(anonymousTokenKey, anonymousToken);

    return anonymousToken;
};
